import dispatcher from '../dispatcher';
import popupToggleProto from '../popup/popup-toggle.component';

var elementProto = Object.create(HTMLButtonElement.prototype);

elementProto.createdCallback = function() {
	popupToggleProto.createdCallback.apply(this);
}
elementProto.attachedCallback = function() {
	var self = this;

	popupToggleProto.attachedCallback.apply(this);

	this._job = this.getAttribute('data-job');

	this.addEventListener('click', function(e) {
		dispatcher.dispatch({
			type: 'select:setValue',
			id: 'job-select',
			value: self._job
		});
	});
}
elementProto.detachedCallback = function() {
	popupToggleProto.detachedCallback.apply(this);
}

document.registerElement('job-button', {
	prototype: elementProto,
	extends: 'button'
});